// Tracks in-flight Drive uploads per department so the management card can block a
// disconnect while an upload is still running. Upload sites call begin()/end() around
// the Drive transfer; the modal reads isDriveBusy() before allowing disconnect.

const active = new Map<string, number>();
const listeners = new Set<() => void>();

export function beginDriveUpload(departmentId: string): void {
  active.set(departmentId, (active.get(departmentId) ?? 0) + 1);
  listeners.forEach(fn => fn());
}

export function endDriveUpload(departmentId: string): void {
  const next = (active.get(departmentId) ?? 0) - 1;
  if (next <= 0) active.delete(departmentId);
  else active.set(departmentId, next);
  listeners.forEach(fn => fn());
}

export function isDriveBusy(departmentId: string): boolean {
  return (active.get(departmentId) ?? 0) > 0;
}

export function subscribeDriveActivity(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

/** Test-only helper to reset shared state between cases. */
export function __resetDriveActivity(): void {
  active.clear();
}
